import './BenefitsAdditionalContent.scss';
import { Grid } from '@mui/material';
import { visuallyHidden } from '@mui/utils';


const BenefitsAdditionalContent = ({ data }) => {
  const imagesData = [
    {
      path: '/images/benefits/additional-content/flight.png',
      alt: 'Domestic Basic fares'
    },
    {
      path: '/images/benefits/additional-content/seats.png',
      alt: 'Seat inventory'
    },
    {
      path: '/images/benefits/additional-content/ancillary.png',
      alt: 'Discounted ancillary pricing'
    }
  ];
  if (!data) {
    return null;
  }

  return (
    <Grid
      container
      sx={{
        '@media (max-width: 900px)': {
          justifyContent: 'center'
        },
        '@media (max-width: 600px)': {
          justifyContent: 'normal'
        }
      }}
    >
      <Grid item xs={12} sm={10} md={12}>
        <section
          aria-labelledby="additional-content-id"
          className="benefits-additional-content"
        >
          <h2 className="title" id="additional-content-id">
            {data.title}
          </h2>
          <ul className="container">
            {data.sections.map((section, index) => {
              return (
                <li className="content-item" key={`ben2-${section.id}`}>
                  <img
                    alt={imagesData[index].alt}
                    aria-hidden
                    src={process.env.PUBLIC_URL + imagesData[index].path}
                  />
                  <h3 className="container-title">{section.title} <span style={visuallyHidden}>{` ${index+1} of ${data.sections.length}`}</span></h3>
                </li>
              );
            })}
          </ul>
        </section>
      </Grid>
    </Grid>
  );
};

export default BenefitsAdditionalContent;
